import { render, staticRenderFns } from "./tigerPayments.vue?vue&type=template&id=1ff47a99"
import script from "./tigerPayments.vue?vue&type=script&lang=js"
export * from "./tigerPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports